"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouterDom = require("react-router-dom");

var _StyledLayout = require("../../StyledLayout");

var _StyledLink = _interopRequireDefault(require("../../StyledLink"));

var _SvgIcon = _interopRequireDefault(require("../../SvgIcon"));

var _InlineSvgIcon = _interopRequireDefault(require("../../InlineSvgIcon"));

var _StyledPopover = require("./StyledPopover");

var _excluded = ["children", "disabled", "hoverBlue", "onClick", "textOnlyMenu", "withIcon", "iconSrc", "fullWidth", "href", "reactRouterLink", "forceHover", "onKeyDown", "onKeyUp"];

// Replace InlineSvgIcon with react-inline-svg
var PopoverLink = function PopoverLink(_ref) {
  var children = _ref.children,
      disabled = _ref.disabled,
      hoverBlue = _ref.hoverBlue,
      onClick = _ref.onClick,
      textOnlyMenu = _ref.textOnlyMenu,
      withIcon = _ref.withIcon,
      iconSrc = _ref.iconSrc,
      fullWidth = _ref.fullWidth,
      href = _ref.href,
      reactRouterLink = _ref.reactRouterLink,
      forceHover = _ref.forceHover,
      onKeyDown = _ref.onKeyDown,
      onKeyUp = _ref.onKeyUp,
      rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, disabled ? /*#__PURE__*/_react["default"].createElement(_StyledPopover.PopoverItem, {
    fullWidth: fullWidth,
    ariaDisabled: true
  }, /*#__PURE__*/_react["default"].createElement(_StyledLayout.Box, {
    flex: true,
    align: "center"
  }, withIcon && !iconSrc && /*#__PURE__*/_react["default"].createElement(_InlineSvgIcon["default"], (0, _extends2["default"])({
    link: true,
    medium: true
  }, rest)), iconSrc && /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], {
    size: "sm",
    src: iconSrc
  }), /*#__PURE__*/_react["default"].createElement(_StyledPopover.PopoverLinkText, {
    mediumGrey: true,
    textOnlyMenu: textOnlyMenu,
    withIcon: withIcon,
    iconSrc: iconSrc
  }, children))) : /*#__PURE__*/_react["default"].createElement(_StyledPopover.PopoverItem, {
    onKeyDown: onKeyDown,
    onKeyUp: onKeyUp,
    forceHover: forceHover,
    hoverBlue: hoverBlue,
    fullWidth: fullWidth,
    tabIndex: "0"
  }, /*#__PURE__*/_react["default"].createElement(_StyledLink["default"], (0, _extends2["default"])({
    large: true,
    veryDark: true,
    withIcon: true,
    fullWidth: true,
    onClick: onClick,
    href: !reactRouterLink && href,
    to: reactRouterLink ? href : undefined,
    as: reactRouterLink && _reactRouterDom.Link,
    tabIndex: "-1"
  }, rest), withIcon && !iconSrc && /*#__PURE__*/_react["default"].createElement(_InlineSvgIcon["default"], (0, _extends2["default"])({
    link: true,
    medium: true
  }, rest)), iconSrc && /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], {
    size: "sm",
    src: iconSrc
  }), /*#__PURE__*/_react["default"].createElement(_StyledPopover.PopoverLinkText, {
    textOnlyMenu: textOnlyMenu,
    withIcon: withIcon,
    iconSrc: iconSrc
  }, children))));
};

PopoverLink.defaultProps = {
  children: null,
  disabled: false,
  hoverBlue: true,
  onClick: null,
  textOnlyMenu: false,
  withIcon: false,
  iconSrc: null,
  fullWidth: false,
  href: null,
  reactRouterLink: false,
  forceHover: false,
  onKeyDown: undefined,
  onKeyUp: undefined
};
PopoverLink.propTypes = {
  children: _propTypes["default"].node,
  disabled: _propTypes["default"].bool,
  hoverBlue: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  textOnlyMenu: _propTypes["default"].bool,
  withIcon: _propTypes["default"].bool,
  iconSrc: _propTypes["default"].node,
  fullWidth: _propTypes["default"].bool,
  href: _propTypes["default"].string,
  reactRouterLink: _propTypes["default"].bool,
  forceHover: _propTypes["default"].bool,
  onKeyDown: _propTypes["default"].func,
  onKeyUp: _propTypes["default"].func
};
var _default = PopoverLink;
exports["default"] = _default;